// eslint-disable-next-line import/no-anonymous-default-export
export default {
  TRIPS_TRACKING: 'trips_tracking',
  APP_DRIVER_LOCATION: 'appDriverLocation',
  TRIP_RECORDS: 'trip_records'
};
